import { render, staticRenderFns } from "./OrthoMenu.vue?vue&type=template&id=07dc2c4d&"
import script from "./OrthoMenu.vue?vue&type=script&lang=js&"
export * from "./OrthoMenu.vue?vue&type=script&lang=js&"
import style0 from "./OrthoMenu.vue?vue&type=style&index=0&id=07dc2c4d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports